module.exports = __webpack_public_path__ + "static/img/14.5b1ad07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/14.png
// module id = cCwQ
// module chunks = 1